import * as React from 'react';
import { Button } from '@repo/ui-web';

type StateToggleProps<T extends string | number> = {
  options: readonly T[];
  value: T;
  onChange: (value: T) => void;
  label?: string;
  formatLabel?: (value: T) => string;
};

export function StateToggle<T extends string | number>({
  options,
  value,
  onChange,
  label,
  formatLabel,
}: StateToggleProps<T>) {
  return (
    <div className="space-y-2">
      {label ? (
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          {label}
        </p>
      ) : null}
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <Button
            key={String(option)}
            type="button"
            size="md"
            variant={value === option ? 'default' : 'outline'}
            onClick={() => onChange(option)}
          >
            {formatLabel ? formatLabel(option) : String(option)}
          </Button>
        ))}
      </div>
    </div>
  );
}
